import AuthService from "../login/auth.service";
import axios from "axios";
import { compromisoSocio, comprobantes } from "../../components/generico/utils/UrlAPI";

class ActividadesEducacionService {
  async getActividades() {
    var config = {
      method: "get",
      url: compromisoSocio + "actividades?canal=WEB",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + AuthService.getCurrentToken(),
      },
    };

    return await axios(config);
  }

  async getComprasTicket() {
    var config = {
      method: "get",
      url: compromisoSocio + "actividades/pagoactividades",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + AuthService.getCurrentToken(),
      },
    };

    return await axios(config);
  }
  async suscripcionActividadesValida(_nroActividad) {
    var data = JSON.stringify({
      canal: "WEB",
      numeroActividad: _nroActividad,
      modo: "S",
    });

    var config = {
      method: "post",
      url: compromisoSocio + "actividades/pago",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(config);
  }
  async suscripcionActividadesConfirma(_nroActividad, _cuentaDebito, _importe, _cantidadEntradas) {

    var data = JSON.stringify({
      canal: "WEB",
      numeroActividad: _nroActividad,
      cuentaDebito: _cuentaDebito,
      importeDebito: _importe,
      cantidad: _cantidadEntradas
    });

    var config = {
      method: "post",
      url: compromisoSocio + "actividades/pago",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data,
    };

    return await axios(config);
  }

  async descagarComponente(titulo, nroOperacion, nroSocioTitular, cuentaDebito, moneda, subtitulo, nroActividad, nombreActividad, fecha, hora, ciudad, costo, total, local) {

    var _url = comprobantes + "comprobantes/v2/pago-actividades-educacion";


    var data = JSON.stringify({
      titulo: titulo,
      nroOperacion: nroOperacion,
      nroSocioTitular: nroSocioTitular,
      cuentaDebito: cuentaDebito,
      moneda: moneda,
      subtitulo: subtitulo,
      nroActividad: nroActividad,
      nombreActividad: nombreActividad,
      fecha: fecha,
      hora: hora,
      ciudad: ciudad,
      costo: costo,
      total: total,
      local: local
    });

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);

  }

  async descargarComprobanteCompras(titulo, nroOperacion, nroSocioTitular, cuentaDebito, moneda, subtitulo, nroActividad, nombreActividad, fecha, hora, ciudad, costo, total, local) {

    var _url = comprobantes + "comprobantes/reimpresion/v2/pago-actividades-educacion";
    var data = JSON.stringify({
      titulo: titulo,
      nroOperacion: nroOperacion,
      nroSocioTitular: nroSocioTitular,
      cuentaDebito: cuentaDebito,
      moneda: moneda,
      subtitulo: subtitulo,
      nroActividad: nroActividad,
      nombreActividad: nombreActividad,
      fecha: fecha,
      hora: hora,
      ciudad: ciudad,
      costo: costo,
      total: total,
      local: local,
      codigoQR: null
    });

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);

  }

}

export default new ActividadesEducacionService();
